	// Custom infinite scroll on collection page
	// Badge rendering function
	function processProduct($product) {
	  const rawData = $product.attr("data-product-options");
	  if (!rawData) return;

	  try {
		const data = JSON.parse(rawData);

		// --- Append Second Image if available ---
	 // --- Append Second Image with Lazy Load ---
	if (data.image2 && data.image2 !== "false") {
	  const secondImg = `
		<img class="t4s-product-hover-img lazyautosizes lazyloadt4sed"
			 data-pr-img2=""
			 data-sizes-scale="1.1"
			 loading="lazy"
			 alt="${data.alt || ''}"
			 src="${data.image2}"
			 data-widths="[100,200,360,400,500,600,700,800,900,1000]"
			 data-optimumx="2"
			 data-sizes="auto"
			 data-srcset="${data.image2}&width=100 100w, ${data.image2}&width=200 200w, ${data.image2}&width=360 360w, ${data.image2}&width=400 400w, ${data.image2}&width=500 500w, ${data.image2}&width=600 600w, ${data.image2}&width=700 700w, ${data.image2}&width=800 800w, ${data.image2}&width=900 900w, ${data.image2}&width=1000 1000w">
	  `;
	  $product.find("[data-replace-img2]").replaceWith(secondImg);
	  $product.find(".t4s-product-img").addClass("is-show-img2");
	}


		// --- Apply Product Badges ---
		const $badgeWrapper = $product.find("[data-product-badge]");
		const badgeOrder = ($badgeWrapper.attr("data-sort") || "")
		  .replace(/ /g, "")
		  .split(",");
		let badgeHtml = "";

		if (badgeOrder.length && $badgeWrapper.length) {
		  badgeOrder.forEach(function (type) {
			switch (type) {
			  case "sale":
				if (data.compare_at_price > data.price && window.g) {
				  let label = "";
				  if (window.v === "2") {
					const percent = (100 * (data.compare_at_price - data.price)) / data.compare_at_price;
					label = window.q.SavePercent.replace("[sale]", Math.round(percent));
				  } else if (window.v === "3") {
					const diff = data.compare_at_price - data.price;
					label = T4SThemeSP.Currency.formatMoney(diff);
				  } else {
					label = window.q.sale;
				  }
				  badgeHtml += `<span class="t4s-badge-item t4s-badge-sale">${label}</span>`;
				}
				break;

			  case "preOrder":
				if (data.isPreoder && window.T) {
				  badgeHtml += `<span class="t4s-badge-item t4s-badge-preorder">${window.q.preOrder}</span>`;
				}
				break;

			  case "new":
				const ageSeconds = window.p - data.dateStart;
				const ageDays = Math.floor(ageSeconds / 86400);
				if (ageDays < window.m && window.y) {
				  badgeHtml += `<span class="t4s-badge-item t4s-badge-new">${window.q.new}</span>`;
				}
				break;

			  case "soldout":
				if (!data.available && window.w) {
				  badgeHtml += `<span class="t4s-badge-item t4s-badge-soldout">${window.q.soldout}</span>`;
				}
				break;

			  default:
				if (data.customBadge && window.b) {
				  for (let i = 0; i < data.customBadge.length; i++) {
					badgeHtml += `<span class="t4s-badge-item t4s-badge-custom t4s-badge-${data.customBadgeHandle[i]}">${data.customBadge[i]}</span>`;
				  }
				}
			}
		  });

		  $badgeWrapper.html(badgeHtml);

		}

	  } catch (e) {
		console.warn("Invalid product JSON", e);
	  }
	}


	function processAllProducts() {
	  $(".t4s-product").each(function () {
		processProduct($(this));
	  });
		  window.ComparederReInit();
	}


	// Run on initial DOM load
	document.addEventListener("DOMContentLoaded", function () {
	   if (typeof Ajaxinate !== "undefined") {
		 let ajaxinate = new Ajaxinate({
		  container: "#Huratips-Loop",
		  pagination: "#Huratips-Pagination",
		  callback: processAllProducts,
		});

	  // Watch for URL changes (filters, pagination, etc.)
	  (function (history) {
		const pushState = history.pushState;
		const replaceState = history.replaceState;

		function onUrlChange() {
		  const url = new URL(window.location.href);
		  const hasFilter = [...url.searchParams.keys()].some((key) =>
			key.startsWith("filter.")
		  );

		  // if (hasFilter) {
			setTimeout(() => {
			  console.log("🔁 Reinitializing Ajaxinate after filter");
			  ajaxinate = new Ajaxinate({
				container: "#Huratips-Loop",
				pagination: "#Huratips-Pagination",
				callback: processAllProducts,
			  });
			}, 1000); // Wait for AJAX to load filtered products
		  // }
		}

		history.pushState = function () {
		  pushState.apply(history, arguments);
		  onUrlChange();
		};

		history.replaceState = function () {
		  replaceState.apply(history, arguments);
		  onUrlChange();
		};

		window.addEventListener("popstate", onUrlChange);
	  })(window.history);
	   }
	});



	// Sticky header and announcement bar
	const announcementBar = document.querySelector(".t4-section-announcement-bar");
	const header = document.querySelector("#shopify-section-top-bar");
	const header_menu = document.querySelector(".t4s-section-header");

	// On load, check if the announcement was closed
	if (localStorage.getItem("announcementClosed") === "true") {
	  if (announcementBar) announcementBar.classList.add("t4s-announcement-hidden");
	  if (header) header.classList.add("header-no-announcement");
	  if (header_menu) header_menu.classList.add("header-no-announcement_menu");
	}

	// Close button logic
	document.querySelectorAll(".t4s-announcement-bar__close").forEach((button) => {
	  button.addEventListener("click", () => {
		if (announcementBar && header) {
		  announcementBar.classList.add("t4s-announcement-hidden");
		  header.classList.add("header-no-announcement");
		  header_menu.classList.add("header-no-announcement_menu");
		  localStorage.setItem("announcementClosed", "true");
		}
	  });
	});
